<template>
    <div class="modal bg-opacity-50 bg-black" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        View (<span class="text-capitalize fst-italic">{{ this.data.entity.equipment_name }}</span>)
                        Stats
                    </h5>
                    <span aria-hidden="true" role="button" @click="close"><i class="fas fa-xmark"></i></span>
                </div>
                <div class="modal-body">
                    <small><i>Please note that some figures may not be fully accurate. Kindly refer to the in-game
                            display for the most up-to-date information</i></small>
                    <div class="stat-group rounded-3  bg-light p-4" v-if="this.show">
                        <div class="row h4 text-center">{{ this.data.entity.equipment_name }} {{
                            levelHandler(this.data.entity.level)
                            }}</div>
                        <div class="container">
                            <!--Equipment Elemental Stats-->
                            <div v-if="this.currentEquipable">
                                <div class="my-3">
                                    <div class="row">
                                        <div class="col-6">Element</div>
                                        <div class="col-6">{{ capitalize(getElement(this.data.entity.element)) }}</div>
                                    </div>
                                    <div class="row">
                                        <div class="col-6">Random Value</div>
                                        <div class="col-6">{{ rvHandler(this.data.entity.rv) }}%</div>
                                    </div>
                                    <div class="row">
                                        <div class="col-6">Engrave Level:</div>
                                        <div class="col-6">{{ this.data.entity.engraveLevel }}</div>
                                    </div>
                                    <div class="row">
                                        <div class="col-6">Required Level</div>
                                        <div class="col-6">{{ this.currentEquipable.requiredLevel }}</div>
                                    </div>
                                    <div class="row" v-if="this.currentEquipable.hero_id != -1">
                                        <div class="col-6">Class</div>
                                        <div class="col-6">{{ classHandler(this.currentEquipable.hero_id) }}</div>
                                    </div>
                                </div>
                                <div v-for="(key) in Object.keys(this.currentStats)" :key="key">
                                    <!-- {{ this.engraveAffectedFields[this.equipmentType].includes("energy") }} -->
                                    <div class="row"
                                        v-if="((typeof this.currentStats[key] != 'object')) && this.exclusiveStats[this.equipmentType].includes(key) && (this.currentStats[key] != 0 || this.engraveAffectedFields[this.equipmentType].includes(key))">
                                        <div class="col-6">{{ this.formatKey(key) }}</div>
                                        <div class="col-6">{{ this.statValueWithRvEngrave(key,
                                            this.currentStats[key])
                                        }}</div>
                                    </div>
                                </div>
                            </div>


                            <div>
                                <span>{{ this.currentEquipment.description }}</span>
                            </div>
                            <div>
                                <span>Selling Price: {{ this.currentEquipment.sellingPrice }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="close">
                        Close
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import store from "node-back-client/src/store";
    export default {
        name: "ViewEquipment",
        data() {
            return {

                weapons: [
                    6
                ],
                armors: [
                    0, 1, 2, 3, 7, 8,
                ],
                rvValue: {
                    0: 0,
                    1: 3.33,
                    2: 6.67,
                    3: 10,
                    4: 13.33,
                    5: 16.67,
                    6: 20,
                    7: 23.33,
                    8: 26.67,
                },
                engraveAffectedFields: {
                    weapon: ["damage", "energy"],
                    armor: ["armor", "magicDefense", "magicArmor"]
                },
                upgradeAffectedFields: [
                    "damage",
                    "energy",
                    "armor",
                    "magicDefense",
                    "magicArmor",
                    "hp"
                ],
                rvAffectedFields: [
                    "damage",
                    "energy",
                    "armor",
                    "magicDefense",
                    "magicArmor",
                    "hp"
                ],
                exclusiveStats: {
                    weapon: ["damage", "energy", "critRate", "hitRate", "element", "range"],
                    armor: ["hp", "armor", "magicDefense","magicArmor", "evasion"],
                    accessory: ["hp", "armor", "magicDefense"]
                },
                element:{
                    0:{
                        fire:1,
                        electric:2,
                        ice:3,
                        poison:4
                    },
                    1:{
                        blaze:1,
                        lightning:2,
                        frozen:3,
                        venom:4
                    }
                },
                withEnhanceTypes: {
                    Armor: 0,
                    Shoes: 1,
                    Pants: 2,
                    Necklace: 3,
                    Headgear: 4,
                    Wings: 5,
                    Weapon: 6,
                    Ring: 7,
                    Earring: 8,
                    Mount: 9,
                    Pet: 10
                },
                heroList: {
                    Swordsman: 0,
                    Archer: 1,
                    Brawler: 2,
                    Shaman: 3,
                    Gunner: 4
                },
                currentEquipment: {},
                currentEquipable: null,
                currentEnhance: {},
                currentStats: {},
                equipmentType: "",
                store: store,
                show: false

            };
        },
        props: {
            data: {
                entity: Object,
                show: Boolean,
            }
        },
        components: {
        },
        methods: {
            close() {
                let data = this.data;
                data.show = false;
            },
            getElement(value){
                if(value===0){
                    return "None"
                }
                return Object.keys(this.element[this.data.entity.elementLevel]).find(key => this.element[this.data.entity.elementLevel][key] === value);
            },
            getType() {
                return this.weapons.includes(this.currentEquipable.type) ? "weapon" : this.armors.includes(this.currentEquipable.type) ? "armor" : ""
            },
            levelHandler(level) {
                return (level > 0 ? `+${level}` : '')
            },
            rvHandler(rv) {
                return this.rvValue[rv];
            },
            classHandler(value) {
                return Object.keys(this.heroList).find(key => this.heroList[key] === value)
            },
            formatKey(key) {
                return key.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) {
                    return str.toUpperCase()
                })
            },
            capitalize(str) {
                return str.charAt(0).toUpperCase() + str.slice(1);
            },
            statValueWithRvEngrave(stat, statValue) {
                let rv = this.rvHandler(this.data.entity.rv)
                let level = this.data.entity.level
                let engravelevel = this.data.entity.engraveLevel
                let computedValue = (stat == "critRate" || stat == "hitRate") ? statValue * 2 : (stat == "evasion") ? statValue / 2 : statValue
                let upgraded = false;
                let displayText;
                if (this.rvAffectedFields.includes(stat)) {
                    if (statValue != 0) {
                        computedValue += (computedValue * (rv / 100))
                        if (rv > 0) upgraded = true;
                    }
                }
                if (this.upgradeAffectedFields.includes(stat)) {
                    if (statValue != 0) {
                        if (stat == "magicDefense" || stat == "hp")
                            computedValue += (computedValue * (parseInt(level) / 9));
                        else
                            computedValue += (computedValue * (parseInt(level) / 9)) + parseInt(level);

                        if (level > 0) upgraded = true;
                    }
                }
                if (this.engraveAffectedFields[this.equipmentType].includes(stat)) {
                    if (engravelevel > 0)
                        upgraded = true;
                    if (this.equipmentType == "weapon") {
                        computedValue += engravelevel
                    }
                    else {
                        if (stat === 'armor' || stat === 'magicArmor')
                            computedValue += engravelevel * 0.2
                        if (stat === 'magicDefense')
                            computedValue += engravelevel * 0.001
                    }
                }
                displayText = `${(upgraded) ? "Base(" + statValue + ") " : ""}${computedValue.toFixed(3).toString()}`;
                return displayText;
            }
        },
        mounted() {
            this.currentEquipment = this.store.custom.equipmentList.find(equip => equip.id == this.data.entity.equipment_id)
            if (this.currentEquipment != {}) {
                if (this.currentEquipment.equipmentType == 0 || this.currentEquipment.equipmentType == 7) {
                    this.currentEquipable = this.currentEquipment.equipable
                    if (Object.values(this.withEnhanceTypes).includes(this.currentEquipable.type)) {
                        this.currentStats = this.currentEquipable.enhance
                        if (!('magicArmor' in this.currentStats)) {
                            this.currentStats['magicArmor'] = 0;
                        }
                        for (const stats of Object.keys(this.data.entity)) {
                            if (this.currentStats[stats] == 0) {
                                if (Object.keys(this.currentStats).includes(stats)) {
                                    this.currentStats[stats] = this.data.entity[stats]
                                }
                            }
                        }
                        this.currentStats['hp'] = parseInt(this.data.entity['hp'] * (this.currentEquipable.requiredLevel / 3) + this.data.entity['hp'])
                        
                    }
                    this.show = true;
                    this.equipmentType = this.getType()
                }

            }
        }
    };
</script>

<style></style>